import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box } from 'grommet';
import { useAppTheme } from '@Components/Context';
import { Seo, UnderConstruction } from '@Components/Control';
import { AdminNavWrapper } from '@Components/Navigation';

const AdminAccountPage = ({
  small,
  location,
  currentUserEmail,
}) => {
  const welcomeMessage = `Welcome, ${currentUserEmail}. Admin Account Management Coming Soon!`;
  const { theme: { page }, isDarkMode, constructionImage } = useAppTheme();
  const usePageBg = isDarkMode ? page.background : page.altBg;
  const useSectionBg = isDarkMode ? page.altBg : page.background;

  return (
    <AdminNavWrapper
      small={small}
      location={location}
      bannerProps={{
        title: 'Manage Authorized Users',
        subTitle: 'Account Settings',
      }}
    >
      <Seo />
      <Box flex width="100%" align="center" justify="center" background={usePageBg}>
        <UnderConstruction
          imageUrl={constructionImage}
          header="Under Construction"
          message={welcomeMessage}
          bgColor={usePageBg}
          sectionBg={useSectionBg}
        />
      </Box>
    </AdminNavWrapper>
  );
};

function mapStateToProps(state) {
  const { adminEmail } = state.adminAuth;

  return {
    currentUserEmail: adminEmail,
  };
}

AdminAccountPage.propTypes = {
  small: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }).isRequired,
  currentUserEmail: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, null)(AdminAccountPage);
